import script from "./AdminPrayerMeetingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPrayerMeetingDetails.vue?vue&type=script&setup=true&lang=js"

import "./AdminPrayerMeetingDetails.vue?vue&type=style&index=0&id=bd122590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd122590"]])

export default __exports__